import { useState } from "react";
import { useVideoPlayer2 } from "./hooks/use-video-player-2-setup-start";
import { useVideoPlayer2ControlsVisible } from "./hooks/use-video-player-helpers";
import { DoubleSpeedTap } from "./VideoPlayer2Controls/DoubleSpeedTap";
import { DoubleTapSeek } from "./VideoPlayer2Controls/DoubleTapSeek";
import { FullscreenButton } from "./VideoPlayer2Controls/FullscreenButton";
import { HelpButton } from "./VideoPlayer2Controls/HelpButton";
import { KeyboardShortcuts } from "./VideoPlayer2Controls/KeyboardShortcuts";
import { PictureInPictureButton } from "./VideoPlayer2Controls/PictureInPictureButton";
import { PlayPauseButton } from "./VideoPlayer2Controls/PlayPauseButton";
import { SettingsButton } from "./VideoPlayer2Controls/SettingsButton";
import { TimeDisplay } from "./VideoPlayer2Controls/TimeDisplay";
import { VideoForwardRewindButtons } from "./VideoPlayer2Controls/VideoForwardRewindButtons";
import { VideoProgressBar } from "./VideoPlayer2Controls/VideoProgressBar";
import { VolumeControl } from "./VideoPlayer2Controls/VolumeControl";

export function VideoPlayer2Controls() {
  const { controlsVisible } = useVideoPlayer2ControlsVisible();
  const player = useVideoPlayer2();
  const [showKeyboardShortcuts, setShowKeyboardShortcuts] = useState(false);

  if (!player.controls) return null;

  return (
    <>
      {player.props.enableDoubleSpeedTap === true && <DoubleSpeedTap />}
      <DoubleTapSeek />
      <div
        className={`video-player-2-controls${
          controlsVisible ? " visible" : " hidden"
        }`}>
        <div className="video-player-2-progressbar-wrapper">
          <VideoProgressBar />
        </div>
        <div className="video-player-2-controls__main-row">
          <div className="video-player-2-controls__left">
            <PlayPauseButton />
            <VolumeControl />
            <VideoForwardRewindButtons />
            <TimeDisplay />
          </div>
          <div className="video-player-2-controls__right">
            <HelpButton onShowKeyboardShortcuts={() => setShowKeyboardShortcuts(true)} />
            <SettingsButton />
            <PictureInPictureButton />
            <FullscreenButton />
          </div>
        </div>
      </div>
      <KeyboardShortcuts 
        show={showKeyboardShortcuts} 
        onClose={() => setShowKeyboardShortcuts(false)} 
      />
    </>
  );
}
